import React, { useEffect } from 'react'

import imgDesktop from '@loyal_images/maintenance/tela_manutencao.jpg'
import imgMobile from '@loyal_images/maintenance/tela_manutencao_mobile.jpg'

const Maintenance = () => {
  useEffect(() => {
    window.addEventListener('load', () => {
      let hideCSDPWidget = document.querySelector('[id^="csdp_"]')

      hideCSDPWidget && hideCSDPWidget.setAttribute('class', 'd-none')
    })
  })

  return (
    <div className='maintenace-content pos-absolute w-100 h-100 bg-white' role='main'>
      <h1>
        <img
          id='imgMobile'
          src={imgMobile}
          alt='opps... estamos em manutenção. Dia 23/02 a gente volta'
        />

        <img
          id='imgDesktop'
          src={imgDesktop}
          alt='opps... estamos em manutenção. Dia 23/02 a gente volta'
        />
      </h1>
    </div>
  )
}

export default Maintenance



// WEBPACK FOOTER //
// ./src/features/Maintenance/Maintenance.js